import API_BASE_URL from "../config/apiConfig";
import createApiClient from "../config/apiClient";

const apiClient = createApiClient(API_BASE_URL);
const API_URL = "/about-page";

// ========== ADMIN ROUTES ==========

export const getAboutPageForAdmin = async () => {
  try {
    const response = await apiClient.get(`${API_URL}/admin`);
    return response.data;
  } catch (error) {
    console.error("Error fetching about page for admin:", error);
    throw error;
  }
};

export const updateAboutPage = async (data) => {
  try {
    const response = await apiClient.put(`${API_URL}/admin`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating about page:", error);
    throw error;
  }
};

// ========== CUSTOMER ROUTES ==========

export const getAboutPageForCustomer = async () => {
  try {
    const response = await apiClient.get(`${API_URL}/customer`);
    return response.data;
  } catch (error) {
    console.error("Error fetching about page for customer:", error);
    throw error;
  }
};
